import { render, staticRenderFns } from "./LinkedAccounts.vue?vue&type=template&id=95f0c11a&scoped=true"
import script from "./LinkedAccounts.vue?vue&type=script&lang=js"
export * from "./LinkedAccounts.vue?vue&type=script&lang=js"
import style0 from "./LinkedAccounts.vue?vue&type=style&index=0&id=95f0c11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f0c11a",
  null
  
)

export default component.exports